import client from '/src/services/client.js';

export default {
    
    getMigrations : (data) => client.get(`migrations/list`,data),
    getMigration : (name,data)=> client.get(`migration/${name}`, data),
    addMigration: (data)=> client.post(`migration`, data),
    deleteMigration : (id,data)=> client.delete(`migration/${id}`,data),
    updateMigration : (id,data)=> client.put(`migration/${id}`, data),
}